export const Blurs = {
    blurExtraLarge: 128,
    blurLarge: 72,
    blurMedium: 40,
    blurNone: 0,
    blurSmall: 16,
};

export type Blur = keyof typeof Blurs;
